// extracted by mini-css-extract-plugin
export var cartHeading = "cart-module--cartHeading--60b6c";
export var checkoutButton = "cart-module--checkoutButton--6fad9";
export var collapseColumn = "cart-module--collapseColumn--f9084";
export var emptyStateContainer = "cart-module--emptyStateContainer--f2de4";
export var emptyStateHeading = "cart-module--emptyStateHeading--7f7d7";
export var emptyStateLink = "cart-module--emptyStateLink--896c1";
export var grandTotal = "cart-module--grandTotal--f2727";
export var labelColumn = "cart-module--labelColumn--2fac6";
export var productHeader = "cart-module--productHeader--70d2c";
export var summary = "cart-module--summary--b0e7a";
export var table = "cart-module--table--b3f51";
export var title = "cart-module--title--53136";
export var totals = "cart-module--totals--53c21";
export var wrap = "cart-module--wrap--cfb0e";